<template>
  <div class="abc-header border1px">
    <img src="~assets/img/common/logo.svg" class="logo" />
  </div>
</template>

<script>
export default {
  name: 'abc-header'
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
